import React from 'react';
import PropTypes from 'prop-types';
import { List, Set, Map, OrderedMap } from 'immutable';
import get from 'lodash/get';

import { Location } from 'models/locations';
import { AddOns as AddOnsModel } from 'models/addons';

import Category from 'components/checkout/add-ons/category';
import RequiredField from 'components/common/required-field';

const propTypes = {
  addOns: PropTypes.shape({ vehicleSize: PropTypes.instanceOf(List) }).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  selectedAddOns: PropTypes.instanceOf(AddOnsModel),
  handleSelectedAddOn: PropTypes.func.isRequired,
  requiredFields: PropTypes.instanceOf(Set),
  requiredFieldErrors: PropTypes.oneOfType([
    PropTypes.instanceOf(Map),
    PropTypes.instanceOf(OrderedMap),
  ]),
  shouldScrollToError: PropTypes.bool,
  setShouldScrollToError: PropTypes.func,
  modifyRequiredFieldList: PropTypes.func,
};

const defaultProps = {
  selectedAddOns: new AddOnsModel(),
  requiredFields: Set(),
  requiredFieldErrors: Map(),
  shouldScrollToError: false,
  setShouldScrollToError: () => {},
  modifyRequiredFieldList: () => {},
  intl: {},
};

const RequiredAddOns = ({
  addOns,
  location,
  selectedAddOns,
  handleSelectedAddOn,
  requiredFields,
  requiredFieldErrors,
  shouldScrollToError,
  setShouldScrollToError,
  modifyRequiredFieldList,
}) => (
  Object.keys(addOns).map(addOnType => (
    <RequiredField
      key={addOnType}
      requiredFields={requiredFields}
      requiredFieldErrors={requiredFieldErrors}
      shouldScrollToError={shouldScrollToError}
      setShouldScrollToError={setShouldScrollToError}
      modifyRequiredFieldList={modifyRequiredFieldList}
    >
      <Category
        addOnType={addOnType}
        addOns={get(addOns, addOnType)}
        location={location}
        selectedAddOns={selectedAddOns}
        handleSelectedAddOn={handleSelectedAddOn}
        required
      />
    </RequiredField>
  ))
);

RequiredAddOns.propTypes = propTypes;
RequiredAddOns.defaultProps = defaultProps;
export default RequiredAddOns;
